export const NOIRLAB_PUBLIC_BASE_URL = 'https://noirlab.edu/public/'
export const NOIRLAB_DATES_FORMAT = 'MMMM DD, YYYY'
